// extracted by mini-css-extract-plugin
export default {"title":"bd532057b0","inner_title":"_58d48709d1","charge_btn":"_50f7060b41"};